import get from 'lodash/get';
import { getSessionUrls } from './../paypal-smart-buttons/paypal-utils';
import request from './../paypal-smart-buttons/request';

const buildShippingMethodsUrl = ({country_code, postal_code}, selectedShippingOption, addressChanged) => {
	const sessionUrls = getSessionUrls();
	const baseUrl = get(sessionUrls, 'shippingUrl');

	const params = [];
	if (addressChanged) {
		params.push(`postalCode=${postal_code}`);
		params.push(`country=${country_code}`);
	}

	if (selectedShippingOption) {
		params.push(`shippingId=${get(selectedShippingOption, 'id')}`);
		const shippingAmount = get(selectedShippingOption, 'value');
		params.push(`shippingAmount=${shippingAmount}`);
	}

	return get(params, 'length') ? `${baseUrl}?${params.join('&')}` : '';
};

const getShippingMethods = (country_code, postal_code, selectedShippingOption = null) => {
	const shippingAddress = {
		country_code,
		postal_code,
	};

	const url = buildShippingMethodsUrl(shippingAddress, selectedShippingOption, selectedShippingOption === null);
	return request(url)
		.then((response) => {
			return response;
		});
};

export default getShippingMethods;
